import * as React from 'react';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { AmorgAdminPageProvider } from '../AmorgAdminPageContext';
import { H1 } from '../../../designSystem/typography/Heading';
import { ArticlesTab } from './_components/ArticlesTab';
import { ReleaseFollowUp } from '../../../amorg-common';
import { articlesClientApi } from '../../../api/articlesClientApi';
import { Table } from '../../../designSystem/Table';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { AdminTab } from '../_components/AdminTab';
import { MessageCard } from '../../../designSystem/Message';
import { Strong } from '../../../designSystem/typography/Body';

export default function ArticlesFollowUp (): JSX.Element 
{
    const [loading, setLoading] = React.useState<boolean>(true);
    const [followups, setFollowups] = React.useState<ReleaseFollowUp[]>([]);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const followups = await articlesClientApi.getFollowups();
            setFollowups(followups);
            setLoading(false);
        };
        getData();
    }, []);

    return (
        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={false} />
            <SingleColumnLayout
                noDivider
                headerContainer={
                    <Flex flexDirection='column' gap={16}>
                        <AdminTab selectedTab='articles' />
                        <ArticlesTab selectedTab='followup' />
                    </Flex>
                }

                contentContainer={

                    <Flex flexDirection='column' gap={16}>

                        <LoadingPageOverlay loading={loading} />

                        <H1>Opfølgning på manglende evaluering</H1>

                        <MessageCard variant='info'>
                            Listen viser lovkrav hvor kunden enten ikke har evalueret artiklen eller har valgt <i>Ingen evaluering foretaget</i>
                        </MessageCard>

                        <Table>
                            <thead>
                                <tr>
                                    <th>Virksomhed</th>
                                    <th>Artikel</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {followups.length === 0 &&
                                    <tr>
                                        <td colSpan={4}>Ingen opfølgning</td>
                                    </tr>
                                }
                                {followups.map(followup => (
                                    <tr key={followup.releaseRecordId}>
                                        <td>{followup.subscriber.companyName || followup.subscriber.siteId}</td>
                                        <td>
                                            <Strong>{followup.list.name} -&gt; {followup.topic.name}</Strong>
                                            <div>{followup.articleTitle}</div>
                                        </td>
                                        <td>
                                            <LinkButton variant='text' text="Vis artikel" href={`${followup.articleId}`} target='_blank' />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Flex>
                } />

        </AmorgAdminPageProvider>
    );
}
